import dayjs from 'dayjs';
export const flatten = (object) => {
    return Object.assign({}, ...(function _flatten(objectBit, path = '') {
        return [].concat(...Object.keys(objectBit || {}).map((key) => typeof objectBit[key] === 'object'
            ? _flatten(objectBit[key], `${path ? path + '.' : ''}${key}`)
            : { [`${path ? path + '.' : ''}${key}`]: objectBit[key] }));
    })(object));
};
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const getFreshnessColorByDate = (date) => {
    const styles = [
        {
            days: 4,
            color: 'red',
            textColor: 'white',
        },
        {
            days: 3,
            color: 'orange',
            textColor: 'black',
        },
        {
            days: 2,
            color: 'yellow',
            textColor: 'black',
        },
        {
            days: 0,
            color: 'green',
            textColor: 'white',
        },
    ];
    const dayDiff = dayjs().diff(date, 'day');
    const style = styles.find((s) => dayDiff >= s.days);
    return style;
};
export const kebabCase = (string) => string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
